import { useState } from "react";
import Cart from "../Cart/Cart";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { PostService } from "../GenericServices/genericService";
import Swal from "sweetalert2";
import { resources_EN } from "../GenericServices/componentUtils";

const CheckOut = ({
  navigate,
  cart,
  total,
  setCart,
  addOrder,
  pathname,
  removeFromCart,
}) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    country: "",
    paymentMethod: "credit",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
  });
  const [cartOpen, setCartOpen] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create order

    orderAPI();
  };

  /* Order API */
  const orderAPI = () => {
    const order = {
      customer_name: formData.name,
      customer_email: formData.email,
      customer_address: formData.address,
      city: formData.city,
      customer_phone_number: formData.phoneNumber,
      customer_alt_number: formData.altNumber,
      nearest_landmark: formData.nearestLandmark,
      delivery_instructions: formData.deliveryInstr,
      order_items: cart,
      total: total,
    };
    const url = "myNewAPI/create_order.php";
    PostService(url, order, modal);
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        setCart([]);
        navigate("/");
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header
        cartCount={cart.length}
        onCartClick={() => setCartOpen(true)}
        searchTerm=""
        setSearchTerm={() => {}}
        pathname={pathname}
        navigate={navigate}
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-600 via-red-600 to-purple-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-black mb-6">Checkout</h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            Complete your purchase and get ready to game
          </p>
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12"
        >
          {/* Left Column - Form */}
          <div>
            <h2 className="text-3xl font-black text-gray-900 mb-6">
              Shipping Information
            </h2>
            <div className="space-y-4">
              <div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent mb-2"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number
                </label>
                <input
                  type="phone"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Alternate Phone Number (Optional)
                </label>
                <input
                  type="phone"
                  name="altNumber"
                  value={formData.altNumber}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Nearest Landmark
                </label>
                <input
                  type="text"
                  name="nearestLandmark"
                  value={formData.nearestLandmark}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Delivery Instruction
                </label>
                <input
                  type="text"
                  name="deliveryInstr"
                  value={formData.deliveryInstr}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
          </div>

          {/* Right Column - Order Summary */}
          <div>
            <h2 className="text-3xl font-black text-gray-900 mb-6">
              Order Summary
            </h2>
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="space-y-4 mb-6">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center"
                  >
                    <div className="flex items-center">
                      <img
                        src={`../myNewAPI/${item.prod_img}`}
                        alt={item.prod_name}
                        className="w-28 h-28 object-cover rounded mr-4"
                      />
                      <div>
                        <p className="font-semibold text-gray-900">
                          {item.prod_name}
                        </p>
                        <p className="text-sm text-gray-600">
                          Qty: {item.quantity}
                        </p>
                      </div>
                    </div>
                    <p className="font-semibold text-gray-900">
                      PKR{" "}
                      {item.prod_price
                        ? new Intl.NumberFormat("en-IN").format(item.prod_price)
                        : 0}
                    </p>
                  </div>
                ))}
              </div>
              <div className="border-t pt-4">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-lg font-semibold">Subtotal:</span>
                  <span className="text-lg font-bold">
                    PKR{" "}
                    {total ? new Intl.NumberFormat("en-IN").format(total) : 0}
                  </span>
                </div>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-lg font-semibold">Shipping:</span>
                  <span className="text-lg font-bold">Free</span>
                </div>
                <div className="flex justify-between items-center mb-6">
                  <span className="text-2xl font-black">Total:</span>
                  <span className="text-2xl font-black text-red-600">
                    PKR{" "}
                    {total ? new Intl.NumberFormat("en-IN").format(total) : 0}
                  </span>
                </div>
                <button
                  type="submit"
                  className="w-full bg-green-600 text-white py-4 px-6 rounded-lg font-bold text-lg hover:bg-green-700 hover:shadow-lg transition duration-200 transform hover:scale-105"
                >
                  Place Order 🚀
                </button>
              </div>
            </div>
          </div>
        </form>
      </main>

      <Footer />
      {cartOpen && (
        <Cart
          cart={cart}
          total={total}
          onRemove={removeFromCart}
          onClose={() => setCartOpen(false)}
          onCheckout={() => {
            navigate("/checkout");
            setCartOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default CheckOut;
